import React, { memo, useCallback } from "react";

import { useAxiomState } from "__AxiomComponents/AxiomHooks/AxiomHooks";
import RemToPx from "__AxiomComponents/RemToPx/RemToPx";

import Icon from "../Icons/Icon";

import "./HawkeyeSearchMenu.scss";
import HawkeyeSearchSubPages from "./HawkeyeSearchSubPages";
import { useSetCurrentPage } from "./HawkeyeSearchHooks.js";

const constantApp = require("__AxiomFramework/code/api_endpoint_modules/apis/auth/constant.js");

function HawkeyeSearchMenu(props) {
  const { pages, onSelection, currentPageIndex, closeMenu, appSettings } = props;

  const [state, dispatch] = useAxiomState(
    {
      selectedPageIndex: [],
      selectedWidgetID: null,
      pages: pages,
    },
    props.appName,
    props.appID,
    "HawkeyeSearchMenu",
    props.componentID
  );

  const currentIndex =
    state.selectedPageIndex.length > 0 ? state.selectedPageIndex : currentPageIndex;
  const currentPage = useSetCurrentPage(state.pages, currentIndex);

  const setSelectedPage = (selectedPageIndex) =>
    dispatch({
      selectedPageIndex: [selectedPageIndex],
      selectedWidgetID: null,
    });

  const setSelectedWidget = (selectedWidgetID) => dispatch({ selectedWidgetID });

  const onSelectionCompletion = (d) => {
    onSelection(d);
    closeMenu();
  };

  const onSubPageSelection = useCallback(
    (d, depth) => {
      let selectedPageIndex = [...currentIndex];
      selectedPageIndex = selectedPageIndex.slice(0, depth);
      selectedPageIndex.push(d);

      dispatch({
        selectedPageIndex: selectedPageIndex,
      });
    },
    [dispatch, currentIndex]
  );

  return (
    <div className="hawkeye-search-overlay">
      <div className={`hawkeye-search-menu`}>
        <div className="hawkeye-search-pages hawkeye-search-section nice-scroll">
          {state.pages.map((p, i) => (
            <div key={`hawkeye_search_menu_parent_${i}`}>
              <div
                className={`hawkeye-page-container ${currentIndex[0] === i && "is-selected"}`}
                onClick={() => setSelectedPage(i)}
                key={`hawkeye_search_menu_${i}`}
              >
                {appSettings && appSettings.showSearchRightPanel && (
                  <div className="hawkeye-search-right-panel"></div>
                )}
                <div>
                  <a key={p.page} className={`hawkeye-search-page `}>
                    {AxiomAPIs.translate(p.page)}
                  </a>
                </div>
                {p.subpages && p.subpages.length > 0 && (
                  <div className="hawkeye-page-arrow-icon-container">
                    <Icon
                      icon={currentIndex[0] === i ? "ICON_ARROW_UP" : "ICON_ARROW_DOWN"}
                      className={`hawkeye-icon-page-arrow ${
                        currentIndex[0] === i && "is-selected"
                      }`}
                    />
                  </div>
                )}
              </div>
              {p.subpages && p.subpages.length > 0 && currentIndex[0] === i && (
                <HawkeyeSearchSubPages
                  pages={p.subpages}
                  onSubPageSelection={onSubPageSelection}
                  depth={1}
                  selectedSubPageIndex={currentIndex}
                />
              )}
            </div>
          ))}
        </div>
        <div className="hawkeye-search-widgets hawkeye-search-section nice-scroll">
          {currentPage &&
            currentPage.widgets.map((widget) => {
              const isSelected = state.selectedWidgetID === widget.widgetID;
              return (
                <div
                  key={widget.widgetID}
                  onClick={() => {
                    setSelectedWidget(widget.widgetID);
                    onSelectionCompletion({
                      pageIndex: currentIndex,
                      widgetID: widget.widgetID ? widget.widgetID : 0,
                    });
                  }}
                  className={`hawkeye-search-widget ${isSelected && "is-selected"}`}
                >
                  <div className="hawkeye-search-widget-image-container">
                    {widget.widgetScreenshotPath ? (
                      <img
                        src={`${constantApp.logFileLocation}${widget.widgetScreenshotPath}`}
                        className="hawkeye-search-widget-thumbnail"
                      />
                    ) : (
                      <Icon
                        icon="WIDGET_ICON"
                        className="hawkeye-search-widget-thumbnail is-default"
                      />
                    )}
                  </div>
                  <div className="hawkeye-search-widget-label-container">
                    <div className="hawkeye-search-widget-question">
                      {AxiomAPIs.translate(widget.widgetquestion)}
                    </div>
                    <div className="hawkeye-search-widget-description">
                      {widget.widgetDescription
                        ? widget.widgetDescription
                        : "Add a widget description."}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        <div className="hawkeye-search-footer">
          <button onClick={closeMenu} className="hawkeye-btn hawkeye-btn-secondary">
            {AxiomAPIs.translate("Close")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default memo(HawkeyeSearchMenu);
